import { createFileRoute, Link } from "@tanstack/react-router";
import { LegalPage } from "@/components/site/LegalPage";
import { openCookieSettings } from "@/lib/consent";

const URL_ = "https://www.investcapital.pt/politica-de-cookies";

export const Route = createFileRoute("/politica-de-cookies")({
  component: Page,
  head: () => ({
    meta: [
      { title: "Política de Cookies — InvestCapital" },
      { name: "description", content: "Lista dos cookies usados em investcapital.pt, para que servem, quanto tempo duram e como alterar a sua escolha." },
      { property: "og:title", content: "Política de Cookies — InvestCapital" },
      { property: "og:description", content: "Cookies essenciais, de estatística e de marketing usados no site InvestCapital." },
      { property: "og:type", content: "article" },
      { name: "twitter:card", content: "summary_large_image" },
      { property: "og:image", content: "https://www.investcapital.pt/og-investcapital.jpg" },
      { property: "og:image:width", content: "1200" },
      { property: "og:image:height", content: "630" },
      { name: "twitter:image", content: "https://www.investcapital.pt/og-investcapital.jpg" },
      { property: "og:url", content: URL_ },
    ],
    links: [{ rel: "canonical", href: URL_ }],
  }),
});

const rows: [string, string, string, string, string][] = [
  ["ic_consent", "InvestCapital", "Essencial", "Guarda a sua escolha de cookies (armazenamento local)", "Até alterar"],
  ["sb-*", "InvestCapital (alojamento)", "Essencial", "Funcionamento técnico do site", "Sessão"],
  ["_ga", "Google", "Estatística", "Distinguir visitantes (Google Analytics)", "2 anos"],
  ["_ga_<ID>", "Google", "Estatística", "Manter o estado da sessão (Google Analytics)", "2 anos"],
  ["_gcl_au", "Google", "Marketing", "Medir conversões de anúncios Google", "3 meses"],
  ["_fbp", "Meta", "Marketing", "Identificar o browser para medir anúncios (Meta Pixel)", "3 meses"],
  ["_fbc", "Meta", "Marketing", "Guardar o clique num anúncio Facebook/Instagram", "3 meses"],
  ["fr", "Meta", "Marketing", "Entrega e medição de anúncios", "3 meses"],
];

function Page() {
  return (
    <LegalPage title="Política de Cookies" updated="26 de outubro de 2026">
      <p>
        Cookies são pequenos ficheiros guardados no seu dispositivo. Usamos cookies essenciais sempre, e cookies de estatística e de marketing
        apenas se os aceitar. Até lá, o Google Analytics, o Google Tag Manager, o Meta Pixel e a API de Conversões não são ativados.
      </p>
      <p>
        <button type="button" onClick={openCookieSettings} className="font-medium text-primary underline">Alterar a minha escolha de cookies</button>
      </p>

      <h2>Cookies utilizados</h2>
      <div className="overflow-x-auto">
        <table className="text-sm">
          <thead><tr><th>Nome</th><th>Fornecedor</th><th>Categoria</th><th>Finalidade</th><th>Duração</th></tr></thead>
          <tbody>
            {rows.map((r) => (
              <tr key={r[0]}>{r.map((c, i) => <td key={i}>{c}</td>)}</tr>
            ))}
          </tbody>
        </table>
      </div>

      <h2>Como desativar</h2>
      <p>
        Pode retirar o consentimento a qualquer momento em “Definições de cookies”, no rodapé, ou apagar os cookies nas definições do seu browser.
        Mais informação em <Link to="/politica-de-privacidade">Política de Privacidade</Link>.
      </p>
    </LegalPage>
  );
}
